import { aBffError } from '../API/bff/bffError';
import { registrarLeadVentaPresencial } from '../API/bff/ventaPresencial/client';
import { esLandingDeVendedor } from './rutaVendedor';

/** Espera antes de cada intento. Dentro del supermercado la señal es mala: se le da aire a la red. */
export const ESPERAS_MS = [0, 2000, 5000];

const esperar = (ms: number): Promise<void> =>
  ms === 0 ? Promise.resolve() : new Promise((resolve) => setTimeout(resolve, ms));

/** 4xx salvo 429: el BFF rechazó el dato y reintentar no lo arregla. */
const esTerminal = (error: unknown): boolean => {
  const { status } = aBffError(error);
  return status >= 400 && status < 500 && status !== 429;
};

export interface LeadDelCotizador {
  /** idContacto del monolito o prospectoId del BFF (puede llegar como número). */
  contactoId?: string;
  landingUrl?: string;
  /**
   * Foto del vendedor y el código de sucursal tomada al empezar la cotización (no se
   * relee el dispositivo). Sucursal vacía: el origen no tenía lista cargada.
   */
  ventaPresencial?: { vendedor: string; sucursal: string };
}

/**
 * Le avisa al BFF qué asesor y en qué sucursal trajo el lead, solo si la
 * cotización empezó en /auto/vendedor. Nunca tira ni bloquea: la cotización
 * sigue igual aunque el BFF no responda. Devuelve true si quedó registrado.
 */
export const registrarVendedorDelLead = async (
  lead: LeadDelCotizador,
  origen: string,
  viaBff: boolean,
  esperas: number[] = ESPERAS_MS
): Promise<boolean> => {
  if (!lead.contactoId || !lead.ventaPresencial || !esLandingDeVendedor(lead.landingUrl)) return false;

  const { vendedor, sucursal } = lead.ventaPresencial;
  const body = {
    origen,
    sistema: viaBff ? ('bff' as const) : ('monolito' as const),
    leadRef: String(lead.contactoId),
    vendedor,
    ...(sucursal ? { sucursal } : {}),
    landingUrl: lead.landingUrl,
  };

  for (const ms of esperas) {
    await esperar(ms);
    try {
      await registrarLeadVentaPresencial(body);
      return true;
    } catch (error) {
      if (esTerminal(error)) {
        console.warn('Venta presencial: el BFF rechazó el vendedor del lead', body.leadRef, aBffError(error).status);
        return false;
      }
    }
  }
  console.warn('Venta presencial: no se pudo registrar el vendedor del lead', body.leadRef);
  return false;
};
